/**
 *
 * MeasurementScheduleSurvey
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { DatePicker, Checkbox, Select } from "antd"
import { filter } from "lodash"
import moment from "moment"
import { getDaysFrequencyRange } from "../../utils/segment/Measure/measureTrack"

import "./index.less"
import { ClockCircleOutlined } from "@ant-design/icons"

const { RangePicker } = DatePicker
const CheckboxGroup = Checkbox.Group
const dateFormat = "DD/MM/YYYY"
const { Option } = Select
/* eslint-disable react/prefer-stateless-function */
class MeasurementScheduleSurvey extends React.Component {
  state = {
    openRangePicker: false,
    date_start: undefined,
    selectedForwarding: [],
    hour_send: undefined,
    hour_close: undefined,
    hour_resend: undefined,
    date_end: undefined,
    count_days_resend: 0,
    date_start_original: undefined,
    date_end_original: undefined,
    hour_send_original: undefined,
    hour_close_original: undefined,
    days_resend_original: undefined,
    hours: [],
    hoursClose: [],
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({ openRangePicker: true })
    }, 1000)

    const date_start = this.props.fourthStepData.date_start
      ? moment(new Date(this.props.fourthStepData.date_start))
      : undefined
    const date_end = this.props.fourthStepData.date_end
      ? moment(new Date(this.props.fourthStepData.date_end))
      : undefined
    const hour_send = this.props.fourthStepData.date_start
      ? moment(new Date(this.props.fourthStepData.date_start))
      : undefined
    const hour_close = this.props.fourthStepData.date_end
    ? moment(new Date(this.props.fourthStepData.date_end))
    : undefined
    const selectedForwarding = this.props.fourthStepData.date_resend
    const hour_resend = this.props.fourthStepData.hour_resend
      ? moment(new Date(this.props.fourthStepData.hour_resend))
      : undefined

    this.props.setStateFrom("date_start", date_start)
    this.props.setStateFrom("date_end", date_end)
    this.props.setStateFrom("hour_send", hour_send)
    this.props.setStateFrom("hour_close", hour_close)
    this.generateHours()

    this.setState(
      {
        date_start,
        date_end,
        hour_send,
        hour_close,
        selectedForwarding,
        hour_resend,
        date_start_original: date_start,
        date_end_original: date_end,
        hour_send_original: hour_send,
        hour_close_original:hour_close,
        days_resend_original: getDaysFrequencyRange(
          selectedForwarding,
          date_start,
          date_end
        ),
      },
      () => {
        this.sendToServer();

      }
    )
  }

  generateHours = () => {
    const { hours } = this.state
    for (let hour = 0; hour < 24; hour++) {
      hours.push(moment({ hour }).format("HH:mm"))
      hours.push(
        moment({
          hour,
          minute: 30,
        }).format("HH:mm")
      )
    }
    this.setState({ hours })
  }


  setStateFrom = (name, value) => {
    if (name === "date_start" || name === "date_end" || name === "hour_send") {
      /* this.props.setStateFrom("hour_send", undefined) */
    const date_start= name === "date_start" ? value : this.state.date_start;
    const date_end= name === "date_end" ? value : this.state.date_end;
    const daySame = date_start && date_end && date_start.isSame(date_end, 'day');
    if (daySame) {
      this.props.setStateFrom("hour_close", undefined)
      this.setState({
        hour_close: undefined,
      })
    }

      this.setState({
        selectedForwarding: [],
        hour_resend: undefined,
      })
    }

    this.setState({ [name]: value }, () => {
      this.sendToServer()
    })
  }

  disabledEndDate = (date_end) => {
    const { date_start } = this.state

    if (!date_end || !date_start) return false
    const date_start_clone = date_start.clone().subtract(1, "day")
    // .day('day')

    return date_end.valueOf() < date_start.startOf("day").valueOf()
  }


  getDaysForward = () => {
    const newDays = []
    let noShowFirstDate = 0
    const plainOptions = [
      { label: "Lu", value: "lu" },
      { label: "Ma", value: "ma" },
      { label: "Mi", value: "mi" },
      { label: "Ju", value: "ju" },
      { label: "Vi", value: "vi" },
      { label: "Sá", value: "sá" },
      { label: "Do", value: "do" },
    ]

    if (this.state.date_start && this.state.date_end) {
      const cloneStartDate = this.state.date_start.clone()
      const cloneEndDate = this.state.date_end.clone().add(1, "days")
      // let cloneEndDate = this.state.date_end.clone().add(1, 'days');

      while (
        cloneStartDate.format("DD-MM-YYYY") !==
        cloneEndDate.format("DD-MM-YYYY")
      ) {
        if (
          this.state.date_start.format("dd") === cloneStartDate.format("dd")
        ) {
          noShowFirstDate++
        }

        newDays.push(cloneStartDate.format("dd"))
        cloneStartDate.add(1, "days")
      }
    }

    if (newDays.length) {
      if (
        this.state.date_start.format("DD-MM-YYYY") ===
        this.state.date_end.format("DD-MM-YYYY")
      )
        return plainOptions
      return filter(plainOptions, (item) => {
        if (
          noShowFirstDate === 1 &&
          this.state.date_start.format("dd") === item.value
        )
          return
        return newDays.includes(item.value)
      })
    }

    return plainOptions
  }

  getDisableTime = (selectedHour) => {
    if (
      this.state.date_start &&
      moment().format("DD-MM-YYYY") ===
        this.state.date_start.format("DD-MM-YYYY") &&
      selectedHour <= moment().format("HH:mm")
    ) {
      return true
    }
    return false
  }
  getDisableTimeClose = (selectedHour) => {
    if (
      this.state.date_end &&
      moment().format("DD-MM-YYYY") ===
        this.state.date_end.format("DD-MM-YYYY") &&
      selectedHour <= moment().format("HH:mm")
    ) {
      return true;
    }
    const { date_start, date_end, hour_send } = this.state;
    const daySame = date_start && date_end && date_start.isSame(date_end, 'day');

    if (daySame && hour_send && selectedHour <= hour_send.format("HH:mm")  ||
    (daySame && hour_send  && moment(selectedHour, 'HH:mm').diff(moment(hour_send.format("HH:mm"), 'HH:mm'), 'hours')< 1)) {
      return true;
    }
    return false;
  }
  disabledCheckboxGroup = () => {
    if (this.state.date_start && this.state.date_end) {
      if (
        this.state.date_start.format("DD-MM-YYYY") ===
        this.state.date_end.format("DD-MM-YYYY")
      )
        return true
    }

    return !this.state.date_start || !this.state.date_end
  }

  sendToServer = () => {
    const params = {
      idMeasurement: this.props.idMeasurement,
      params: {
        date_start: this.state.date_start
          ? `${this.state.date_start.format("DD/MM/YYYY")} ${
              this.state.hour_send
                ? this.state.hour_send.format("HH:mm")
                : "00:00"
            }:00`
          : "",
        date_end: this.state.date_end
        ? `${this.state.date_end.format("DD/MM/YYYY")} ${
          this.state.hour_close
            ? this.state.hour_close.format("HH:mm")
            : "00:00"
        }:00`
      : "",
        date_resend: this.state.selectedForwarding,
        hour_resend: this.state.hour_resend
          ? `${this.state.hour_resend.format("HH:mm")}:00`
          : "",
        auto_save: true,
      },
    }

    this.props.setStateFrom("stepFourthReSend", params)
    this.props.stepFourthWatcher(params)
    this.props.setStateFrom("nameSaving", "Cambios guardados")
  }

  render() {
    return (
      <div className="measurement-schedule-survey">
        <div>
          <div className="measurement-schedule-survey-title">
            Agendar encuesta
          </div>
          <div className="measurement-schedule-survey-content-items" style={{ display:'inline-grid' }}>
            <div
              className="measurement-schedule-survey-item"
              style={{ marginRight: 10 }}>
              <span className="measurement-schedule-survey-item-title">
                Inicio y envió<span className="red">*</span>
              </span>
              <p>
              Selecciona cuándo iniciará y se enviará la encuesta:
              </p>
              <DatePicker
                format={dateFormat}
                allowClear={false}
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
                value={this.state.date_start}
                style={{ width: 224 }}
                onChange={(e) => {
                  // this.props.saveChangeSegment('date_start',e.isSame(this.state.date_start_original));
                  if (this.state.date_end) {
                    if (e.isSameOrBefore(this.state.date_end)) {
                      this.props.setStateFrom("date_start", e)
                      this.setStateFrom("date_start", e)
                    } else {
                      this.props.setStateFrom("date_start", this.state.date_end)
                      this.setStateFrom("date_start", this.state.date_end)
                    }
                    return
                  }
                  this.props.setStateFrom("date_start", e)
                  this.setStateFrom("date_start", e)
                  this.setStateFrom("date_start", e)
                }}
                placeholder="Fecha inicio"
              />
              <Select
                name="horaEnvio"
                style={{ width: 224,left:15 }}
                value={
                  this.state.hour_send
                    ? this.state.hour_send.format("HH:mm")
                    : undefined
                }
                placeholder="Hora de envío"
                disabled={!this.state.date_start}
                allowClear
                onChange={(time) => {
                  this.props.setStateFrom("hour_send", time)
                  this.setStateFrom("hour_send", time)
                }}
                suffixIcon={<ClockCircleOutlined />}>
                {this.state.hours.map((h, hi) => (
                  <Option
                    name="opcionHoraEnvio"
                    disabled={this.getDisableTime(h)}
                    value={h}
                    key={hi}>
                    {h}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="measurement-schedule-survey-item container-fin">
              <span className="measurement-schedule-survey-item-title">
                Fin y cierre<span className="red">*</span>
              </span>
              <p>
              Selecciona cuándo finalizará y cerrará la encuesta:
              </p>
              <DatePicker
                disabled={!this.state.date_start}
                format={dateFormat}
                allowClear={false}
                value={this.state.date_end}
                disabledDate={this.disabledEndDate}
                style={{ width: 224 }}
                onChange={(e) => {
                  this.props.setStateFrom("date_end", e)
                  this.setStateFrom("date_end", e)
                  //   this.props.saveChangeSegment('date_end',e.isSame(this.state.date_end_original));
                }}
                placeholder="Fecha fin"
              />
              <Select
                name="horaCierre"
                style={{ width: 224, left:15 }}
                value={
                  this.state.hour_close
                    ? this.state.hour_close.format("HH:mm")
                    : undefined
                }
                placeholder="Hora de cierre"
                disabled={!this.state.date_end}
                allowClear
                onChange={(time) => {
                  this.props.setStateFrom("hour_close", time)
                  this.setStateFrom("hour_close", time)
                }}
                suffixIcon={<ClockCircleOutlined />}>
                {this.state.hours.map((h, hi) => (
                  <Option
                    name="opcionHoraCierre"
                    disabled={this.getDisableTimeClose(h)}
                    value={h}
                    key={hi}>
                    {h}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div
            className="measurement-schedule-survey-title"
            style={{ marginTop: 16 }}>
            Configuración del reenvío de la encuesta
          </div>
          <div className="measurement-schedule-survey-content-items measurement-schedule-survey-content-items-third">
            <div className="measurement-schedule-survey-item">
              <span className="measurement-schedule-survey-item-title">
                Días de reenvío
              </span>
              <p>
                Selecciona los días de reenvío de la encuesta para aquellos
                colaboradores que no la hayan contestado aún:
              </p>
              <CheckboxGroup
                disabled={this.disabledCheckboxGroup()}
                value={this.state.selectedForwarding}
                onChange={(value) => {
                  if (value.length) {
                    this.props.setStateFrom(
                      "hour_resend",
                      !this.state.hour_resend
                    )
                    this.props.setStateFrom("days_resend", !value.length)
                  } else {
                    this.props.setStateFrom(
                      "hour_resend",
                      this.state.hour_resend
                    )
                    this.props.setStateFrom("days_resend", value.length)
                  }
                  this.setState({ selectedForwarding: value }, () => {
                    this.sendToServer()
                  })
                }}
                className="measurement-schedule-survey-days"
                options={this.getDaysForward()}
              />
            </div>
          </div>
          <div className="measurement-schedule-survey-content-items measurement-schedule-survey-content-items-third">
            <div className="measurement-schedule-survey-item">
              <span className="measurement-schedule-survey-item-title">
                Horario de reenvío
              </span>
              <p>
                Selecciona la hora en la que se reenviará la encuesta a los
                colaboradores:
              </p>
              <Select
                name="horaReenvio"
                style={{ width: 224 }}
                value={
                  this.state.hour_resend
                    ? this.state.hour_resend.format("HH:mm")
                    : undefined
                }
                placeholder="Seleccionar hora"
                disabled={this.disabledCheckboxGroup()}
                allowClear
                onChange={(time) => {
                  if (time) {
                    this.props.setStateFrom(
                      "days_resend",
                      !this.state.selectedForwarding.length
                    )
                    this.props.setStateFrom("hour_resend", !time)
                  } else {
                    this.props.setStateFrom(
                      "days_resend",
                      this.state.selectedForwarding.length
                    )
                    this.props.setStateFrom("hour_resend", time)
                  }
                  this.setStateFrom("hour_resend", time)
                }}
                suffixIcon={<ClockCircleOutlined />}>
                {this.state.hours.map((h, hi) => (
                  <Option name="opcionHoraReenvio" value={h} key={hi}>
                    {h}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        {/* <div className="measurement-schedule-survey-onlypicker">
          <RangePicker
            allowClear={false}
            disabledDate={(current) =>
              current && current < moment().startOf("day")
            }
            className="measurement-schedule-survey-rangepicker"
            open
            format={dateFormat}
            value={[this.state.date_start, this.state.date_end]}
            dateRender={(current, today) => {
              if (
                this.state.selectedForwarding.includes(current.format("dd"))
              ) {
                if (
                  current.isBetween(this.state.date_start, this.state.date_end)
                ) {
                  if (
                    this.state.date_end.format("DD-MM-YYYY") !==
                    current.format("DD-MM-YYYY")
                  ) {
                    return (
                      <div
                        className="ant-picker-cell-inner"
                        style={{
                          border: "1px solid #1890FF",
                          color: "#1890FF",
                          lineHeight: "21px",
                        }}>
                        {current.date()}
                      </div>
                    )
                  }
                }
              }

              return (
                <div className="ant-picker-cell-inner">{current.date()}</div>
              )
            }}
            onChange={(dates) => {
              this.props.setStateFrom("hour_send", undefined)
              this.props.setStateFrom("date_start", dates[0])
              this.props.setStateFrom("date_end", dates[1])
              this.setState(
                {
                  date_start: dates[0],
                  date_end: dates[1],
                  selectedForwarding: [],
                  hour_send: undefined,
                },
                () => {
                  this.sendToServer()
                }
              )
            }}
            // getPopupContainer={(trigger) => trigger.parentNode}
          />
          </div> */}
      </div>
    )
  }
}

MeasurementScheduleSurvey.propTypes = {}

export default MeasurementScheduleSurvey
